BatchGeoStore.addReducer("MapsMarkersManager", function (state, action) {
  state = state || {
    clickedMarker: null,
    lastOpenedMarker: null,
    openedInfoWindows: [],
    openStatus: false,
    paginationCluster: [],
    currentPaginationNumber: 0,
    paginating: false,
  };

  function removeUnpinnedInfoWindows(infoWindows) {
    return infoWindows.filter((item) => item.infoWindow.pinned_);
  }

  switch (action.type) {
    /*
     * When a marker gets clicked, we set the state to that marker and the
     * openStatus to true. This signals that we want to open this marker.
     */
    case "MAPSMARKERS_MANAGER_MARKER_CLICKED":
      if (action.marker) {
        return Object.assign({}, state, {
          clickedMarker: action.marker,
          openStatus: true,
        });
      }
      return Object.assign({}, state, {
        clickedMarker: null,
        openStatus: false,
      });
    /*
     * This action will get called automatically when a new infowindow
     * is going to open. It also removes any reference to the last
     * Infowinfow. If you just want to close an infowindow as if
     * the user just clicked on the X button, then dispatch
     * 'MAPSMARKERS_MANAGER_INFOWINDOW_CLOSE_VIA_X' instead.
     */
    case "MAPSMARKERS_MANAGER_INFOWINDOW_DESTROY":
      return Object.assign({}, state, {
        openedInfoWindows: [],
        openStatus: false,
      });
    /*
     * When an infowindow opens, we set add the infowindow to openedInfoWindows
     * as an object with the marker id,
     * but we also need the marker associated to this infoWindow.
     * We reset the status to true just in case the same infowindow
     * needs to open but it was closed via the X button. In that case
     * the infoWindow will be the same but the openStatus will change.
     */
    case "MAPSMARKERS_MANAGER_INFOWINDOW_OPEN":
      return Object.assign({}, state, {
        openedInfoWindows: [
          ...removeUnpinnedInfoWindows(state.openedInfoWindows),
          { id: action.id, infoWindow: action.infoWindow },
        ],
        lastOpenedMarker: action.marker,
        clickedMarker: action.marker,
        openStatus: true,
        paginating: false,
      });

    /*
     * when an infowindow closes, we remove it from openInfoWindows by id
     */
    case "MAPSMARKERS_MANAGER_INFOWINDOW_CLOSE":
      return Object.assign({}, state, {
        openedInfoWindows: [
          ...state.openedInfoWindows.filter(
            (openInfoWindow) => openInfoWindow.id !== action.id,
          ),
        ],
        openStatus:
          [
            ...state.openedInfoWindows.filter(
              (openInfoWindow) => openInfoWindow.id !== action.id,
            ),
          ].length > 0
            ? true
            : false,
      });

    /*
     * When we close the infobox via the close button, the marker
     * and the table row (advanced mode) remain selected.
     * So we only update the status of the infobox.
     */
    case "MAPSMARKERS_MANAGER_INFOWINDOW_CLOSE_VIA_X":
      return Object.assign({}, state, {
        openStatus: false,
      });

    /*
     * Keep track of those markers that are part of a cluster
     * That require pagination. Whenever the cluster resets
     * We start back at 0 to display the first page number.
     */
    case "MAPSMARKERS_MANAGER_INFOWINDOW_PAGINATION_CLUSTER":
      return Object.assign({}, state, {
        paginationCluster: action.paginationCluster,
        currentPaginationNumber: 0,
      });

    /*
     * Resets the pagination options to defaults
     */
    case "MAPSMARKERS_MANAGER_MARKER_PAGINATE_RESET":
      return Object.assign({}, state, {
        paginationCluster: [],
        clickedMarker: null,
        currentPaginationNumber: 0,
        paginating: false,
      });
    /*
     * Whenever we click on a pagination arrow, we update
     * the current page number and we set the paginating
     * status to true. This will prevent the pagination
     * cluster from regenerating unnecessarily. We set it back
     * to false once the infobox opens.
     */
    case "MAPSMARKERS_MANAGER_MARKER_PAGINATE":
      return Object.assign({}, state, {
        clickedMarker: action.marker,
        currentPaginationNumber: action.currentPaginationNumber,
        paginating: true,
      });

    case "MAPSMARKERS_MANAGER_RESET":
      return Object.assign({}, state, {
        clickedMarker: null,
        lastOpenedMarker: null,
        openedInfoWindows: [],
        openStatus: false,
        paginationCluster: [],
        currentPaginationNumber: 0,
      });

    default:
      return state;
  }
});
